<template>
  <div id="content" class="manage_default_data">

    <ConfirmModal :dialogVisible='showConfirmDialog' @close="showConfirmDialog = false" @confirmed="confirmDelete($event)" :message="$t('Are you sure? Once deleted, this assessment can’t be recovered.')" ></ConfirmModal>
      <div class="content_div stats" v-if="data">
        <div class="titreEtFilterAssessments">
          <h1 class="titre">{{ $t("INTERNAL ASSESSMENTS") }}</h1>
          <div class="sort-selector"  @click="focusSelect">
            <select ref="sortSelect" v-model="sortBy" class="sort-select">
              <option value="">{{$t("Sort by...")}}</option>
              <option value="nameASC">{{$t("Name (A to Z)")}}</option>
              <option value="nameDESC">{{$t("Name (Z to A)")}}</option>
              <option value="statusASC">{{$t("Status (Draft first)")}}</option>
              <option value="statusDESC">{{$t("Status (Closed first)")}}</option>
              <option value="deadlineASC">{{$t("Deadline (Closest first)")}}</option>
              <option value="deadlineDESC">{{$t("Deadline (Latest first)")}}</option>
            </select>
          </div>

        </div>
        <div class="assessmentsList mt20" v-if="sortedAssessments.length > 0">
            <div class="oneAssessments" v-for="(assessment,a) in sortedAssessments" :key="a">

              <div class="content">
                <div class="">
                  <div class="name_and_status">

                    <router-link v-if="(assessment.user.$oid == uid.$oid ||assessment.user.$oid == uid)  && assessment.status != 'completed' && assessment.status != 'closed'" class="button" name="button" :to="'/internalassessment_creation/'+assessment._id.$oid">
                      <div class="status inprogress" v-if="assessment.status == 'progress'">
                          <span class="status-text">{{ $t("In progress")}}</span>
                      </div>
                      <div class="status draft" v-if="assessment.status == 'draft'">
                          <span class="status-text">{{ $t("Draft")}}</span>
                      </div>
                      <div class="status completed" v-if="assessment.status == 'completed'">
                          <span class="status-text">{{ $t("Completed")}}</span>

                      </div>
                      <div class="status closed" v-if="assessment.status == 'closed'">
                          <span class="status-text">{{ $t("Closed")}}</span>

                      </div>
                    </router-link>
                    <router-link v-else-if="(assessment.user.$oid == uid.$oid ||assessment.user.$oid == uid)  && (assessment.status == 'completed' || assessment.status == 'closed')" class="button" name="button" :to="'/assessment_results/'+assessment._id.$oid">
                      <div class="status">
                        <div class="status inprogress" v-if="assessment.status == 'progress'">
                            <span class="status-text">{{ $t("In progress")}}</span>
                        </div>
                        <div class="status draft" v-if="assessment.status == 'draft'">
                            <span class="status-text">{{ $t("Draft")}}</span>
                        </div>
                        <div class="status completed" v-if="assessment.status == 'completed'">
                            <span class="status-text">{{ $t("Completed")}}</span>

                        </div>
                        <div class="status closed" v-if="assessment.status == 'closed'">
                            <span class="status-text">{{ $t("Closed")}}</span>

                        </div>
                      </div>
                    </router-link>
                    <div class="status" v-else>
                      <div class="status inprogress" v-if="assessment.status == 'progress'">
                          <span class="status-text">{{ $t("In progress")}}</span>
                      </div>
                      <div class="status draft" v-if="assessment.status == 'draft'">
                          <span class="status-text">{{ $t("Draft")}}</span>
                      </div>
                      <div class="status completed" v-if="assessment.status == 'completed'">
                          <span class="status-text">{{ $t("Completed")}}</span>

                      </div>
                      <div class="status closed" v-if="assessment.status == 'closed'">
                          <span class="status-text">{{ $t("Closed")}}</span>

                      </div>
                    </div>

                    <span class='assess_name'>{{assessment.name}}

                    <div class="" v-if="assessment.deadline">
                      <small class="deadlineTitle">{{ $t("Due : ")}}</small>
                      <small class="deadlineValue">{{transformDate(assessment.deadline.date.split(' ')[0])}}</small>
                    </div>
                    </span>

                  </div>

                </div>

                <div class="actions">
                  <router-link :to="'/do_assessment/'+mytoken(assessment.judges)+'/'+assessment._id.$oid" v-if="amijudge(assessment.judges) && (assessment.status == 'progress' || assessment.status == 'completed')" class="next_step_btn">Assess</router-link>
                  <div class="other_actions">
                    <router-link v-if="(assessment.user.$oid == uid.$oid ||assessment.user.$oid == uid)  && assessment.status != 'completed' && assessment.status != 'closed'" class="button" name="button" :to="'/internalassessment_creation/'+assessment._id.$oid">
                      <img :src="require('@/assets/eyeInno.svg')" alt=""/>
                    </router-link>
                    <span v-else class="button unavailalbr" name="button" >
                      <img :src="require('@/assets/eyeInno.svg')" alt=""/>
                    </span>
                    <router-link v-if="( data.access_user == 'FullProjectAccess' || (assessment.user.$oid == uid.$oid ||assessment.user.$oid == uid) )  && (assessment.status != 'draft')" class="button" name="button" :to="'/assessment_results/'+assessment._id.$oid">
                      <img :src="require('@/assets/assessResults.svg')" alt=""/>
                    </router-link>
                    <span v-else class="button unavailalbr" name="button" >
                      <img :src="require('@/assets/assessResults.svg')" alt=""/>
                    </span>
                    <button v-if="(uid.$oid || uid) " type="button" class="button" @click="duplicateAssessment(assessment._id.$oid)">
                      <img :src="require('@/assets/duplicateInno.svg')" alt=""/>
                    </button>
                    <span v-else class="button unavailalbr" name="button" >
                      <img :src="require('@/assets/duplicateInno.svg')" alt=""/>
                    </span>
                    <button v-if="(assessment.user.$oid == uid.$oid ||assessment.user.$oid == uid) " type="button" class="button" @click="deleteAssessment(assessment)">
                      <img :src="require('@/assets/trashInno.svg')" alt=""/>
                    </button>
                    <span v-else class="button unavailalbr" name="button" >
                      <img :src="require('@/assets/trashInno.svg')" alt=""/>
                    </span>
                  </div>

                </div>
              </div>
            </div>
        </div>
            <div class="assessmentsList" v-else>
              {{$t("No assessment found")}}
          </div>


        <h1 class="titre mt50">{{ $t("INNOPEARL ASSESSMENTS") }}</h1>
        <div class="assessmentsList" v-if="data.innopearl_assessment.length > 0">
            <div class="oneAssessments" v-for="(assessment,a) in data.innopearl_assessment" :key="a">
              <div class="content">
                <div class="name_and_status">
                  <div class="status inprogress" v-if="assessment.status == 'progress'">
                      <span class="status-text">{{ $t("In progress")}}</span>
                  </div>
                  <div class="status draft" v-if="assessment.status == 'draft'">
                      <span class="status-text">{{ $t("Draft")}}</span>
                  </div>
                  <div class="status completed" v-if="assessment.status == 'completed'">
                      <span class="status-text">{{ $t("Completed")}}</span>

                  </div>
                  <div class="status closed" v-if="assessment.status == 'closed'">
                      <span class="status-text">{{ $t("Closed")}}</span>

                  </div>

                  <span class='assess_name'>{{assessment.name}}</span>

                </div>
                <div class="actions">
                  <!-- <div class="other_actions innospeacial">
                  v-if="( data.access_user == 'FullProjectAccess' || (assessment.user.$oid == uid.$oid ||assessment.user.$oid == uid) )  && (assessment.status != 'draft')"
                -->
                    <router-link  v-if="( data.access_user == 'FullProjectAccess' || (assessment.user.$oid == uid.$oid ||assessment.user.$oid == uid) ) "  class=" other_actions innospeacial" name="button" :to="'/innopearl_assessment_results/'+assessment._id.$oid">
                      <img :src="require('@/assets/assessResults.svg')" alt=""/>
                    </router-link>
                  <!-- </div> -->


                </div>
              </div>
            </div>
        </div>
        <div class="assessmentsList" v-else>
          {{$t("No assessment found")}}
      </div>
      </div>
  </div>
</template>
<script>
import api from '../tools/api';
import { mapState } from 'vuex';
// import router from '@/router'
import ConfirmModal from '@/components/modals/ConfirmModal.vue'

 import { toast } from 'vue-sonner'
export default {
  components: {
    ConfirmModal
  },
  name: 'ManageAssessments',
  data() {
    return {
      pageInfo: {
        mainTitle : "My innovator assessments",
        subTitle : "Manage assessments",
      },
      data: null,
      sortBy: '',
      showConfirmDialog: false,
      asked_for_delete: null,
    }
  },
  methods:{
    focusSelect() {
    this.$refs.sortSelect?.focus();
  },
    duplicateAssessment(a){
      api.post(process.env.VUE_APP_API_URL+"/restrict/duplicateassessment/"+a,{
        headers: {
            'Content-Type': 'application/json',
        }
      }).then( () => {

        if(this.$route.query.project){
          api.get(process.env.VUE_APP_API_URL+"/restrict/getAssessmentManager/"+this.$route.query.project).then( (r) => {
            this.data = r.data;
            toast.success("Assessment has been duplicated.");
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
           });
        }else{
          api.get(process.env.VUE_APP_API_URL+"/restrict/getAssessmentManager").then( (r) => {
            this.data = r.data;
            toast.success("Assessment has been duplicated.");
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        }
      }).catch( error => {
        if(error.response.data.message) toast.error(error.response.data.message);
        else toast.error("Sorry, an error occurs. Please try again !");
          this.showConfirmDialog = false;
      })
    },
    deleteAssessment(v){
      this.showConfirmDialog = true;
      this.asked_for_delete = v._id.$oid;
    },
    mytoken(judges){
        var ju = judges.find(item => {
        if (item.user && this.uid.$oid) {
          return item.user.$oid == this.uid.$oid;
        }
        else if (item.user && this.uid) {
          return item.user.$oid == this.uid;
        }

        return false;
      });
      console.log(ju);
      if(ju)return ju.accessToken.$oid;
      else return false;
    },
    amijudge(judges){
      return judges.some(item => {
        if(item.user) return (item.user.$oid == this.uid || item.user.$oid == this.uid.$oid);
        return false;
      });
    },
     transformDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear() % 100).padStart(2, '0');
  return `${day}/${month}/${year}`;
},

    confirmDelete(){
      //trashassessment
      api.delete(process.env.VUE_APP_API_URL+"/restrict/trashassessment/"+this.asked_for_delete,{
        headers: {
            'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r.data);
        toast.success("Removed from the database");
        // this.loadDictDatas();
        if(this.$route.query.project){
          api.get(process.env.VUE_APP_API_URL+"/restrict/getAssessmentManager/"+this.$route.query.project).then( (r) => {
            this.data = r.data;

          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        }else{
          api.get(process.env.VUE_APP_API_URL+"/restrict/getAssessmentManager").then( (r) => {
            this.data = r.data;

          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        }
        this.asked_for_delete =null;
            this.showConfirmDialog = false;
      }).catch( () => {

        toast.error("Sorry, an error occurs. Please try again !");
        this.showConfirmDialog = false;
      })
    },
  },
  mounted(){
    this.uu = this.uid;
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
     if(this.$route.query.project){
       api.get(process.env.VUE_APP_API_URL+"/restrict/getAssessmentManager/"+this.$route.query.project).then( (r) => {
         this.data = r.data;

       }).catch( (e) => {
         console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     });
     }else{
       api.get(process.env.VUE_APP_API_URL+"/restrict/getAssessmentManager").then( (r) => {
         this.data = r.data;

       }).catch( (e) => {
         console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     });
     }

  },
  computed:{
    ...mapState(['uid']),
    sortedAssessments() {
    return [...this.data.my_assessment].sort((a, b) => {
      switch (this.sortBy) {
        case 'nameASC':
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        case 'nameDESC':
          return (b.name.toLowerCase() || '').localeCompare(a.name.toLowerCase() || '');
        case 'statusASC':
          var statusOrder = {
             'draft': 1,
             'progress': 2,
             'completed': 3,
             'closed': 4
           };
           // Compare based on defined order
           return (statusOrder[a.status] || 999) - (statusOrder[b.status] || 999)
        case 'statusDESC':
          var statusOrderDESC = {
             'draft': 4,
             'progress':3,
             'completed': 2,
             'closed': 1
           };
         // Compare based on defined order
         return (statusOrderDESC[a.status] || 999) - (statusOrderDESC[b.status] || 999)
        case 'deadlineASC':
          if (!a.deadline?.date && !b.deadline?.date) return 0;
          if (!a.deadline?.date) return 1;  // Push a to the end
          if (!b.deadline?.date) return -1; // Push b to the end
          return new Date(a.deadline.date) - new Date(b.deadline.date);
        case 'deadlineDESC':
            if (!a.deadline?.date && !b.deadline?.date) return 0;
            if (!a.deadline?.date) return -1;
            if (!b.deadline?.date) return 1;
          return new Date(b.deadline.date) - new Date(a.deadline.date);
        default:
          return 0;
      }
    });
  }
  }

}
</script>
<style scoped>

.manage_default_data{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}


.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 7px 25px;
  color:#FFF;
  display:inline-block;
  font-size: 16px;
  text-transform: uppercase;
}

.mt20{
  margin-top:20px;
  margin-bottom: 20px;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
box-sizing: border-box;
margin-top:10px;
margin-bottom: 20px;
padding: 5px;
}

h1.titre{
  text-align: left;
  font-size: 21px;
  line-height: 25px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  opacity: 1;
  display: block;
}

.oneAssessments .content{
  display:flex;
  gap:10px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.name_and_status{
  display:flex;
  gap:20px;
align-items: center;
}
.assess_name{
  font-weight: 500;
  font-size: 18px;
}
.assess_name small{
  font-size:15px;
}
.mt50{
  margin-top: 50px;
}

.oneAssessments{
  padding-top:25px;
  padding-bottom: 25px;
  border-bottom:1px solid #FFFFFF;
}

.status{
  color:#3783C5;
  display:flex;
  gap:5px;
  align-items: center;
  width: 130px;
  text-align: center;
  justify-content: center;
  align-items: center;

}

.actions{
  display:flex;
  align-items: center;
  gap:20px;
  margin-top:0px;
}
.actions .button{
  padding-left:15px;
  padding-right: 15px;
  padding-top:5px;
  padding-bottom: 5px;
}

.actions .button.unavailalbr{
  padding-left:15px;
  padding-right: 15px;
  padding-top:5px;
  padding-bottom: 5px;
  opacity:.3;
}

.titreEtFilterAssessments .titre{
  margin:0px;
  padding:0px;
}
.titreEtFilterAssessments{
  display:flex;
  gap:10px;
  align-items:center;
}

.titreEtFilterAssessments .sort-select{

  padding: 5px 10px;
  padding-right:30px;
  border: 1px solid #D1E8FB;
  color:#3783C5;
  border-radius: 20px;
  background-color: transparent;
  z-index:10;
}
.titreEtFilterAssessments .sort-selector{
  position:relative;

}
.titreEtFilterAssessments .sort-selector::after{
  position:absolute;
  top: 8px;
  right:10px;
  content:  url('@/assets/orderbyblue.svg');
  z-index:0;
   pointer-events: none;
}

.assessmentsList{
  background: #3783C512;
  padding: 25px;
  border-radius: 20px;
  margin-top:20px;
}

.status{
  gap:5px;
}
.status.inprogress {
    display: flex;
    align-items: center;
    background-color: #FFAA2A;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.inprogress .status-text {
    color: #fff;
    font-size: 14px;
}
.status.draft {
    display: flex;
    align-items: center;
    background-color: #6C68A2;
      padding: 5px 20px !important;
    border-radius: 15px;
}


.status.draft .status-text {
    color: #fff;
    font-size: 14px;
}

.status.completed {
    display: flex;
    align-items: center;
    background-color: #4ADE80;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.completed .status-text {
    color: #FFF;
    font-size: 14px;
}


.status.closed {
    display: flex;
    align-items: center;
    background-color: #ADB3B5;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.closed .status-text {
    color: #fff;
    font-size: 14px;
}

  .aname{
    color:#04246A;
  }

  .deadlineTitle{
    color:#000;

  }
  .deadlineValue{
    color:#3783C5;
  }

.status{
  gap:5px;
}


.other_actions{
  background:#FFF;
  padding:5px;
  border-radius:20px;
}

.other_actions.innospeacial {

  padding:10px !important;
  border-radius:50%;
}

.innospeacial img{
  height:25px !important;
  width:25px !important;
    object-fit:contain;
}

@media screen and (max-width:1200px){
  .name_and_status{
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
  }
}
@media screen and (max-width:690px){
  .actions{
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
  }
  .oneAssessments .content{
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
  }
}
</style>
